import type { GuideAffiliations } from 'types/guide';

export const GUIDE_AFFILIATIONS: Record<GuideAffiliations, string> = {
    MANTA_PARTNER: 'Manta Partner',
    MANTA_GUIDE: 'Manta Guide'
};
